const strings = {
  textModal: {
    editModalTitle: 'Editar Consultoria',
  },
}

export default strings
